module.exports = __webpack_public_path__ + "img/avator.7ddc2490.svg";